'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require('./lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('webDashboard.app.shared.services', []).service('_', _lodash2.default); /*
                                                                                                          * Want to add a service? go/generator-shared-service
                                                                                                          */


// WEBPACK FOOTER //
// ./src/app/shared/services/index.js